// One synchronous generation owns persisted queries and every in-flight
// authenticated intent. Kept dependency-free so the transport can use it too.
let generation = 0;
const listeners = new Set<() => void>();

export function authenticatedCacheGeneration(): number { return generation; }

export function onAuthenticatedSessionChange(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function advanceAuthenticatedCacheGeneration(): number {
  ++generation;
  for (const listener of listeners) listener();
  return generation;
}

export function requireAuthenticatedGeneration(expected: number): void {
  if (expected !== generation) throw new Error('AUTHENTICATED_SESSION_CHANGED');
}
